import App from './App.vue';

export default {
  path: '/CDS_VF_PublicityDetail',
  name: 'CDS_VF_PublicityDetail',
  component: App,
  meta: {
    pageProperty: {
      title: '市民への情報提供履歴詳細',
      controller: 'CDS_CTR_PublicityDetail',
    },
  },
};
